(() => {
  function init() {
    const root = document.querySelector('[data-bjp-mobile-cart]');
    const summary = document.querySelector('.main-product .product-summary');
    const form = summary?.querySelector('[data-type="add-to-cart-form"]');
    const nativeAdd = form?.querySelector('[name="add"]');
    if (!root || !form || !nativeAdd) return;
    const data = JSON.parse(root.querySelector('[data-mobile-product]').textContent);
    const mobile = window.matchMedia('(max-width: 767px)');
    const html = document.documentElement;
    const panel = root.querySelector('dialog');
    const add = root.querySelector('[data-mobile-add]');
    const submit = root.querySelector('[data-mobile-submit]');
    const quantity = root.querySelector('#BjpMobileQuantity');
    const minus = root.querySelector('[data-mobile-minus]');
    const sizeButtons = [...root.querySelectorAll('[data-mobile-size]')];
    const fields = [...summary.querySelectorAll('.product-variants .variant-field')];
    const sizeIndex = data.options.findIndex(name => name.toLowerCase() === 'size');
    const needsSize = sizeIndex >= 0 && data.variants.length > 1;
    const initial = data.variants.find(v => String(v.id) === form.querySelector('[name="id"]').value) || data.variants[0];
    let chosen = !needsSize || data.variants.some(v => v.id === data.selected);
    let selected = initial;
    let busy = false;
    let insertedQuantity;
    let returnFromGuide = false;
    const optionValues = () => fields.map(field => field.querySelector('input:checked,select')?.value);
    const candidate = size => data.variants.find(v => v.options.every((value, i) => value === (i === sizeIndex ? size : optionValues()[i])));
    const error = message => root.querySelectorAll('[data-mobile-bar-error],[data-mobile-panel-error]').forEach(node => {
      node.textContent = message || '';
      node.hidden = !message;
    });
    function update() {
      if (!mobile.matches) return;
      const soldOut = !data.variants.some(v => v.available) || (chosen && !selected?.available);
      add.disabled = soldOut || busy;
      add.querySelector('[data-mobile-add-label]').textContent = busy ? data.labels.adding : soldOut ? data.labels.soldOut : data.labels.add;
      const size = chosen ? data.labels.size.replace('__SIZE__', selected?.options[sizeIndex] || '') : data.labels.select;
      root.querySelector('[data-mobile-caption]').textContent = `${(selected || initial).price}${needsSize && !soldOut ? ` · ${size}` : ''}`;
      root.querySelector('[data-mobile-price]').textContent = (selected || initial).price;
      submit.disabled = !chosen || soldOut || busy;
      submit.textContent = busy ? data.labels.adding : data.labels.add;
      nativeAdd.disabled = soldOut;
      nativeAdd.classList.toggle('disabled', soldOut);
      nativeAdd.setAttribute('aria-disabled', String(soldOut));
      form.classList.toggle('disabled', soldOut);
      sizeButtons.forEach(button => {
        const variant = candidate(button.dataset.mobileSize);
        button.disabled = !variant?.available || busy;
        button.setAttribute('aria-pressed', String(chosen && selected?.options[sizeIndex] === button.dataset.mobileSize));
      });
      minus.disabled = Number(quantity.value) <= 1 || busy;
      root.querySelector('[data-mobile-plus]').disabled = busy;
      quantity.disabled = busy;
    }
    function setQuantity(value) {
      quantity.value = Math.max(1, Math.floor(Number(value) || 1));
      let input = form.querySelector('[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.append(input);
        insertedQuantity = input;
      }
      input.value = quantity.value;
      update();
    }
    function openPanel() {
      if (!mobile.matches || busy || panel.open) return;
      error('');
      update();
      panel.showModal();
      (panel.querySelector('[data-mobile-size][aria-pressed="true"]:not(:disabled)') || panel.querySelector('[data-mobile-size]:not(:disabled)') || panel.querySelector('[data-mobile-close]')).focus();
    }
    function syncFromMain() {
      const values = optionValues();
      chosen = !needsSize || !!values[sizeIndex];
      selected = data.variants.find(v => v.options.every((value, i) => value === values[i])) || (data.variants.length === 1 ? initial : null);
      if (selected && mobile.matches) {
        form.querySelector('[name="id"]').value = selected.id;
        const url = new URL(location.href);
        url.searchParams.set('variant', selected.id);
        history.replaceState(history.state, '', url);
      }
      error('');
      update();
    }
    function chooseSize(value) {
      const field = fields[sizeIndex];
      const input = [...field.querySelectorAll('input')].find(node => node.value === value) || field.querySelector('select');
      if (!input || !candidate(value)?.available) return;
      if (input.type === 'radio') input.checked = true;
      else input.value = value;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    function mode() {
      html.classList.toggle('bjp-mobile-cart-ready', mobile.matches);
      if (mobile.matches) {
        if (needsSize && !chosen) fields[sizeIndex]?.querySelectorAll('input').forEach(input => { input.checked = false; });
        update();
      } else {
        if (panel.open) panel.close();
        insertedQuantity?.remove();
        insertedQuantity = null;
        quantity.value = 1;
        if (needsSize && !chosen) fields[sizeIndex]?.querySelectorAll('input').forEach(input => { input.checked = input.value === initial.options[sizeIndex]; });
      }
    }
    add.addEventListener('click', () => chosen ? nativeAdd.click() : openPanel());
    submit.addEventListener('click', () => { if (chosen && selected?.available && !busy) { setQuantity(quantity.value); nativeAdd.click(); } });
    nativeAdd.addEventListener('click', event => {
      if (!mobile.matches) return;
      if (busy || !chosen) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!busy) openPanel();
        return;
      }
      error('');
      busy = true;
      update();
    }, true);
    summary.querySelector('.product-variants')?.addEventListener('change', syncFromMain);
    sizeButtons.forEach(button => button.addEventListener('click', () => chooseSize(button.dataset.mobileSize)));
    root.querySelector('[data-mobile-close]').addEventListener('click', () => panel.close());
    panel.addEventListener('click', event => {
      if (event.target !== panel) return;
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
    });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]')].filter(node => !node.hidden && node.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const guide = summary.querySelector('[data-bjp-size-guide]');
    const guideButton = root.querySelector('[data-mobile-guide]');
    guideButton.hidden = !guide;
    guideButton.addEventListener('click', () => { returnFromGuide = true; panel.close(); guide.click(); });
    if (guide) document.getElementById(guide.dataset.bjpSizeGuide)?.addEventListener('close', () => {
      if (returnFromGuide) { returnFromGuide = false; openPanel(); }
    });
    minus.addEventListener('click', () => setQuantity(Number(quantity.value) - 1));
    root.querySelector('[data-mobile-plus]').addEventListener('click', () => setQuantity(Number(quantity.value) + 1));
    quantity.addEventListener('change', () => setQuantity(quantity.value));
    form.addEventListener('bjp:cart-added', () => { if (panel.open) panel.close(); });
    form.addEventListener('bjp:cart-error', event => error(event.detail?.message || data.labels.error));
    form.addEventListener('bjp:cart-idle', () => { busy = false; update(); });
    new MutationObserver(() => {
      if (html.classList.contains('side-cart-open') || html.classList.contains('site-panel-open') || html.classList.contains('bjp-mobile-cookie-open')) {
        if (panel.open) panel.close();
      }
    }).observe(html, {attributes: true, attributeFilter: ['class']});
    const cookieNodes = new Set();
    const syncCookies = () => {
      document.querySelectorAll('.cookies-bar,#shopify-pc__banner').forEach(node => {
        if (!cookieNodes.has(node)) {
          cookieNodes.add(node);
          node.addEventListener('transitionend', syncCookies);
          new MutationObserver(syncCookies).observe(node, {attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']});
        }
      });
      html.classList.toggle('bjp-mobile-cookie-open', [...cookieNodes].some(node => {
        if (node.hidden || node.getAttribute('aria-hidden') === 'true' || (node.matches('.cookies-bar') && !node.classList.contains('show'))) return false;
        const style = getComputedStyle(node);
        return node.isConnected && node.getClientRects().length && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      }));
    };
    new MutationObserver(syncCookies).observe(document.body, {childList: true, subtree: true});
    syncCookies();
    mobile.addEventListener('change', mode);
    window.addEventListener('pageshow', update);
    root.hidden = false;
    mode();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
